export enum FeatureFlag {
  AirAssureZeroingEnabled = 'enable_aa_zeroing',
  DashboardVerticalCompactEnabled = 'enable_dashboard_vertical_compact',
  DashboardRestoreOnDragEnabled = 'enable_dashboard_restore_on_drag',
  ExpandManageSubscriptionsRows = 'enable_expand_manage_subscriptions_rows',
  FileImportCountEnabled = 'enable_file_import_count',
  EnableManageDevicesCurrentReadings = 'enable_manage_devices_current_readings',
  HistoryChartCustomDateRange = 'enable_history_chart_custom_date_range',
  StreamLatestTelemetry = 'enable_stream_latest_telemetry',
}
